// extracted by mini-css-extract-plugin
export default {"buttonContainer":"fileActionBar_buttonContainer__A0gLg","icon":"fileActionBar_icon__LQCHY","iconUpload":"fileActionBar_iconUpload__8I0UZ"};